import { Box, Text } from "@chakra-ui/react";
import React from "react";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";

type Props = {
  text: string;
  author?: string;
};

const Quote = ({ text, author }: Props) => {
  return (
    <Box p={5}>
      <Text position="relative" display="inline-block">
        <FaQuoteLeft
          size={40}
          style={{ position: "absolute", top: -10, left: 0, opacity: 0.2 }}
        />
        {text}
        <FaQuoteRight
          size={40}
          style={{ position: "absolute", bottom: -10, right: 0, opacity: 0.2 }}
        />
      </Text>
      {author ? (
        <Text fontSize="sm" mt={5}>
          {" "}
          - {author}
        </Text>
      ) : null}
    </Box>
  );
};

export default Quote;
